<template>
    <v-container>
        <v-row>
            <v-col md="8" lg="6" offset-lg="2">
                <router-view></router-view>
            </v-col>
            <v-col md="4" lg="3">
                <v-row>
                    <v-col cols="12">
                        <v-card
                                outlined
                        >
                            <v-card-title>
                                <v-icon left>mdi-information-outline</v-icon>
                                {{ $t('user.info') }}
                            </v-card-title>
                            <v-card-text>
                                <v-divider></v-divider>
                                <br>
                                <v-list dense>
                                    <v-list-item :to="{ name: 'profile'}">
                                        <v-list-item-icon>
                                            <v-icon>mdi-account</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            {{ $t('user.profile') }}
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item :to="{ name: 'privacy'}">
                                        <v-list-item-icon>
                                            <v-icon>mdi-folder-account</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            privacy
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item :to="{ name: 'terms'}">
                                        <v-list-item-icon>
                                            <v-icon>mdi-file-document-outline</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            terms & conditions
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  export default {
    name: 'Profile'
  }
</script>

<style scoped>

</style>
